<template>
  <div class="w_1200">
    <div class="flex_jc" style="width: 100%;">
      <img src="../../assets/img/logo.png" class="responsive-img" alt="" />
    </div>
    <div>
      <div class="neirong ">
        中企易融（山东）企业发展有限公司成立于2020年，致力于企业咨询服务、供应链管理服务，解决企业各发展阶段的需求，整合服务资源，多方面解决企业发展羁绊。公司在企业综合服务方面取得卓越成绩，为多家企业进行产业链服务和金融服务，2019年被中国企业家协会评为“2019年中国创新力（新锐）企业20佳”。为帮助企业开拓国际市场，应对多变的国际贸易局势，公司在乌干达设立了东非贸工农一体化综合体，为入驻企业提供“线下展厅+线上展览”、“跨境电商+海外仓储”、“投资咨询+金融服务”等服务，带领国内企业走进非洲，发掘新商机。
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.responsive-img {
  width: 320px;
  height: 130px;
}
.neirong{
  padding: 5rem;
}
/* 媒体查询，当屏幕宽度小于等于 768px 时调整样式 */
@media (max-width: 768px) {
  .responsive-img {
    width: 200px;
    height: 80px;
  }
  .neirong{
  padding: 10px !important;
}
}
</style>